module.exports.PageLinks = {
    about: "about-hardisty",
    general_enquiry: "general-enquiry",
    news_insight: "news-and-insights",
    branch_finder: "branch-finder",
    area_cover: "area-guides",
    branch_contact: "contact-us",
    team_contact: "contact-us",
    teams: "meet-the-team",
    request_valuation: "request-valuation",
    privacy_policy: "privacy-policy",
    terms_condition: "terms-condition",
    cookie_policy: "cookie-policy",
    book_a_viewing: "book-a-viewing",
    book_a_valuation: "request-a-valuation/home-visit-valuation",
    send_to_friend: "send-to-friend",
    property_to_rent: "property/to-rent",
    property_for_sale: "property/for-sale",
    newhomes_for_sale: "new-developments/for-sale",
    reviews: "customer-reviews",
    property_management: "landlords/property-management",
    financial_services: "financial-services",
    guides_resources: "guides-and-resources",
    contact_investment_centre: "contact-investment-centre",
    investment_centre: "investment-centre",
    careers: "careers",
    current_vacancies: "careers/current-vacancies",
    job_details: "careers/job-details",
    case_study: "case-study",
    newhomes: "new-homes",

}